import React from 'react';
import InfoTooltip from '../InfoTooltip';
import './MeasurementForm.css';

interface EndOfCampaignReportInputProps {
  file: File | null;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const EndOfCampaignReportInput: React.FC<EndOfCampaignReportInputProps> = ({
  file,
  onChange,
  disabled = false
}) => {
  return (
    <div className="form-group">
      <label htmlFor="endOfCampaignReport" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        End of Campaign Report <span className="required">*</span>
        <InfoTooltip text="Expected columns: 'exposure_date', 'url', 'device', 'adunit', 'impressions', and 'creative_id'. Device should be: phone, desktop, tablet. Adunit should be: '<width>x<height>' (e.g., '300x250'). Date format should be: 'YYYY-MM-DD'." />
      </label>
      <input
        type="file"
        id="endOfCampaignReport"
        accept=".xlsx,.xls,.csv"
        onChange={onChange}
        disabled={disabled}
        required
      />
      <p className="file-help">Excel (.xlsx, .xls) or CSV file</p>
      {file && (
        <div className="file-preview">
          <span className="file-name">{file.name}</span>
          <span className="file-size">({(file.size / 1024 / 1024).toFixed(2)} MB)</span>
        </div>
      )}
    </div>
  );
};

export default EndOfCampaignReportInput;
